import { VideoCard } from "../model/home";
import { getData } from "../utils/HttpUtils";

export async function getExporeList(
  order_type: "newest" | "oldest" | "popular",
  subject: string,
  ref_id?: string
): Promise<{
  ref_id: string,
  cards: VideoCard[],
}> {
  return getData("/api/solve/expore_cards", !!ref_id ? { order_type, subject, ref_id } : { order_type, subject });
}
